import React, {Component} from 'react';
import AisinoInput from "./AisinoInput";
import {AisinoButton} from "../../button"
import AisinoRow from "../../rowAndCol/AisinoRow";
import AisinoCol from "../../rowAndCol/AisinoCol";


class AisinoInputAndButton extends Component {
    constructor(props){
        super(props)

    }

    static defaultProps={
        button_type:"button",//默认为蓝色字体  具体样式参考 antd的button    type
        button_show:true,
        button_disabled:false,
        input_disabled:false,
        input_style:{},
        button_style:{},
        button_click:null,
        button_content:"",
        onChange:null,
        onBlur:null
    };
    onChange(val){
        // console.log(val.target.value)
        this.props.onChange(val.target.value);
    }
  /*  shouldComponentUpdate(nextProps, nextState, nextContext) {
        console.log(this.props)
        return true;
    }*/


    render() {
        //复合组件   仅供在form.item下使用
        return (
            <AisinoRow>
                <AisinoCol sm={20} xs={18} >
                    <AisinoInput autoComplete="off" placeholder={this.props.placeholder} value={this.props.value} disabled={this.props.input_disabled} onChange={this.onChange.bind(this)}  onBlur={this.props.onBlur}  onPressEnter={this.props.onPressEnter} id={this.props.id} style={this.props.input_style} />
                </AisinoCol>
                <AisinoCol span={4}>
                    <AisinoButton  type={this.props.button_type} disabled={this.props.button_disabled} size={"middle"}
                                          style={{textAlign:"center",display:this.props.button_show?"":"none",...this.props.button_style}}  onClick={this.props.button_click}>{this.props.button_content}</AisinoButton>
                </AisinoCol>
            </AisinoRow>
        );
    }
}

export default AisinoInputAndButton;
